import {slideUp, slideDown} from "./helpers/animation.js";

export class Accordion {
  constructor(el, activeClass = '--active') {
    this.wrapper = el;
    this.head = el.querySelector('.js-accordion-head');
    this.body = el.querySelector('.js-accordion-body');
    this.activeClass = activeClass;

    this.init();
  }

  init() {
    this.head.addEventListener('click', () => {
      const isActive = this.wrapper.classList.contains(this.activeClass);
      isActive ? this.close() : this.open();
    })
  }

  open() {
    this.wrapper.classList.add(this.activeClass);
    slideDown(this.body);
  }

  close() {
    this.wrapper.classList.remove(this.activeClass);
    slideUp(this.body, 300);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-accordion').forEach((item) => {
    new Accordion(item, 'accordion--active')
  })
});
